import { css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Paragraph } from "@/components/paragraph";

@customElement("eko-hint")
export class Hint extends Paragraph {
  static styles = [
    ...Paragraph.styles,
    css`
      :host {
        --eko-paragraph-text-size: var(--eko-t-font-size-text-md);

        color: oklch(var(--eko-t-color-text-weaker));
        max-width: var(--eko-t-width-text-container);
        text-wrap: pretty;
      }
      :host([error]) {
        color: oklch(var(--eko-t-color-status-danger));
      }
    `,
  ];

  @property({ reflect: true, type: Boolean }) error: boolean = false;

  constructor() {
    super();
    this.size = "md";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-hint": Hint;
  }
}

export default Hint;
